import { ChangeEvent, useCallback, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Password } from "../../controls";
import { useStore } from "../../store";
import { UserService } from "../../services";
import CommonModal from "../../components/CommonModal";
import PasswordChecklist from "../../components/PasswordChecklist";
import { Utils } from "../../utils";
import CopyRight from "../../components/CopyRight";
import Logo from "../../components/Logo";
import ThemeToggle from "../../components/ThemeToggle";

function ResetPassword() {
  const location = useLocation();
  const [modalShow, setModalShow] = useState(false);
  const { setIsLoading } = useStore((s: any) => s);
  const [values, setValues] = useState({
    password1: "",
    password2: "",
  });
  const [validationMessage, setValidationMessage] = useState<string>("");
  const navigate = useNavigate();
  const handleInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      setValues({
        ...values,
        [name]: value,
      });
    },
    [values]
  );

  useEffect(() => {
    let token = location.search?.split("?token=")[1] || "";
    if (!token || token.length !== 36)
      setValidationMessage(`Invalid password reset token.`);
  }, [location.search]);

  const hanldeSubmit = useCallback(
    async (e: any) => {
      e.preventDefault();

      let token = location.search?.split("?token=")[1] || "";
      if (!token || token.length !== 36)
        return setValidationMessage(`Invalid password reset token.`);
      if (!values?.password1)
        return setValidationMessage("Please provide your password.");
      if (!Utils.checkPasswordStrength(values.password1).ok)
        return setValidationMessage(
          "Password must be at least 8 characters and include a letter, a number, and a special character."
        );
      if (values?.password1 !== values?.password2)
        return setValidationMessage("Password is not matching.");

      setIsLoading(true);
      let result = await UserService.resetPassword({
        token,
        newPassword: values?.password1,
      });
      if (result?.error) {
        setIsLoading(false);
        setValidationMessage(result?.error);
        return;
      }

      setValidationMessage("");
      setIsLoading(false);
      setModalShow(true);
    },
    [values, setIsLoading, setModalShow, setValidationMessage, location.search]
  );

  return (
    <>
      <div className="container">
        <div className="row h-100vh">
          <div className="col-md-5 loginLeft position-relative">
            <div className="d-flex align-items-center h-100 w-100">
              <div className="w-100">
                <div className="text-md-start text-center">
                  <Link to="/">
                    <Logo width={100} height={100} />
                  </Link>
                </div>
                <h1>Reset your password</h1>
                <p>Choose your new password</p>
                <div className="formMain">
                  <Form>
                    <Password
                      label="New password"
                      placeholder="Enter your new password"
                      name="password1"
                      value={values?.password1}
                      onChange={handleInputChange}
                    />
                    <PasswordChecklist value={values?.password1} />
                    <Password
                      label="Confirm new password"
                      placeholder="Enter new password again"
                      name="password2"
                      value={values?.password2}
                      onChange={handleInputChange}
                    />
                    {validationMessage && (
                      <div className="validation-message">
                        {validationMessage}
                      </div>
                    )}
                    <Button title="Reset password" onClick={hanldeSubmit} />
                  </Form>
                </div>
                <div className="authThemeToggle mt-4">
                  <ThemeToggle />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center registerMain gap-2">
              <div className="d-flex gap-2">
                <Link to="/login">Login here</Link>
              </div>
            </div>
          </div>
          <div className="col-md-1"></div>
          <div className="col-md-6 position-relative">
            <div className="d-md-flex align-items-center h-100 d-none">
              <img
                src="/assets/imgs/forget-password.png"
                className="w-100"
                alt=""
              />
            </div>
            <CopyRight />
          </div>
        </div>
      </div>
      <CommonModal
        title="Success!"
        message="Your password has been reset. Please use new password to login."
        show={modalShow}
        onHide={() => {
          setModalShow(false);
          navigate("/login");
        }}
      />
    </>
  );
}

export default ResetPassword;
